import api from './api.service';

export default {
    createVendor(data) {
        return api.post('/vendor/vendors', data);
    },
    getAllVendors(companyId) {
        const url = companyId ? `/vendor/vendors?companyId=${companyId}` : '/vendor/vendors';
        return api.get(url);
    },
    getVendorById(id, companyId) {
        return api.get(`/vendor/vendors/${id}?companyId=${companyId}`);
    },
    updateVendor(id, data) {
        return api.put(`/vendor/vendors/${id}`, data);
    },
    deleteVendor(id) {
        return api.delete(`/vendor/vendors/${id}`);
    },
    checkVendorIdExists(vendorId, companyId, excludeId = null) {
        let url = `/vendor/vendors/check-id?vendorId=${vendorId}&companyId=${companyId}`;
        if (excludeId) {
            url += `&excludeId=${excludeId}`;
        }
        return api.get(url);
    },
    checkVendorEmailExists(email, companyId, excludeId = null) {
        let url = `/vendor/vendors/check-email?email=${encodeURIComponent(email)}&companyId=${companyId}`;
        if (excludeId) {
            url += `&excludeId=${excludeId}`;
        }
        return api.get(url);
    },
    // Vendor Document methods
    uploadVendorDocuments(vendorId, companyId, formData) {
        return api.post(`/vendor/vendors/documents?vendorId=${vendorId}&companyId=${companyId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    getVendorDocuments(vendorId, companyId) {
        return api.get(`/vendor/vendors/documents?vendorId=${vendorId}&companyId=${companyId}`);
    },
    getVendorDocumentById(id, companyId) {
        return api.get(`/vendor/vendors/documents/${id}?companyId=${companyId}`);
    },
    viewVendorDocument(id, companyId) {
        return api.get(`/vendor/vendors/documents/${id}/view?companyId=${companyId}`, {
            responseType: 'blob'
        });
    },
    updateVendorDocument(id, companyId, data) {
        return api.put(`/vendor/vendors/documents/${id}?companyId=${companyId}`, data);
    },
    deleteVendorDocument(id, companyId) {
        return api.delete(`/vendor/vendors/documents/${id}?companyId=${companyId}`);
    }
};
